import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 0,
  top: 0,
  marginRight: 2,
  marginTop: 2,
  color: theme.palette.neutral.main,
  background: theme.palette.primary.main,
  transform: "translate(50%, -50%)",
  padding: 4,
  "&:hover": {
    "@media (hover: hover)": {
      color: theme.palette.neutral.main,
      "& svg": {
        animation: "rotate 1s normal 1",
      },
    },
  },
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.pxToRem(36),
  },
  "@keyframes rotate": {
    "0%": {
      transform: "rotate(0)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

const SpinningCloseButton = ({ onClick, className = "", ...props }) => {
  return (
    <StyledIconButton aria-label="close" className={className} onClick={onClick} size="large" {...props}>
      <CloseIcon fontSize="inherit" />
    </StyledIconButton>
  );
};

SpinningCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SpinningCloseButton;
